<template lang="html">
<div class="v-scope-documentacion-addcontacto">
<div class="row-start">

        <p><strong>{{$t('registro.nuevo_contacto_titulo')}}</strong></p>

        <div class="contenedor-input type-text one-slot">
            <label for="">{{$t('registro.nombre')}}*</label>
            <input type="text" v-validate="'required|min:3|max:150'" name="nombreUsuario" v-model="newuser.nombre">
            <span class='error' v-if="clicked">{{ errors.first('nombreUsuario') }}</span>
        </div>

        <div class="contenedor-input type-text one-slot">
            <label for="">{{$t('registro.apellidos')}}*</label>
            <input type="text" v-validate="'required|min:3|max:150'" name="apellidosUsuario"
                v-model="newuser.apellidos">
            <span class='error' v-if="clicked">{{ errors.first('apellidosUsuario') }}</span>
        </div>


        <div :class="['contenedor-input row-start type-text three-slot']" v-if="brand.requestTipoContacto">
            <label for="">{{$t('registro.tipo_contacto')}}*</label>

            <template v-if="!!dominiosOrder && !!dominiosOrder.tiposContacoEmpresa">
                <div class="radio-container" v-for="(tipo,key) in dominiosOrder.tiposContacoEmpresa">
                    <input type="checkbox" :value="tipo[0]" :id="'tipo-contacto-'+tipo[0]"
                        v-model="newuser.tipoContacto" name="tipocontactoUsuario">
                    <label :for="'tipo-contacto-'+tipo[0]">{{tipo[1]}}</label>
                </div>
            </template>
            <span class='error' v-if="clicked">{{ errors.first('tipocontactoUsuario')}}</span>
        </div>

        <div class="contenedor-input type-text one-slot">
            <label for="">{{$t('registro.email')}}*</label>
            <input type="text" v-validate="'email|required'" name="emailUsuario" v-model="newuser.email">
            <span class='error' v-if="clicked">{{ errors.first('emailUsuario') }}</span>
        </div>

        <div class="contenedor-input type-text one-slot">
            <label for="">{{$t('registro.telefono_1')}}*</label>
            <input type="text" v-validate="'required|min:9'" name="telefonoUsuario" v-model="newuser.telefono1">
            <span class='error' v-if="clicked">{{ errors.first('telefonoUsuario') }}</span>
        </div>

        <div class="contenedor-input type-text one-slot">
            <label for="">{{$t('registro.telefono_2')}}</label>
            <input type="text" v-validate="'min:9'" name="telefono2Usuario" v-model="newuser.telefono2">
            <span class='error' v-if="clicked">{{ errors.first('telefono2Usuario') }}</span>
        </div>


        <div class="contenedor-input type-text one-slot">
            <label for="">{{$t('registro.cargo')}}*</label>
            <input type="text" autocomplete="none" v-validate="'required|min:3|max:150'" name="cargoUsuario" v-model="newuser.puesto">
            <span class='error' v-if="clicked">{{ errors.first('cargoUsuario') }}</span>
        </div>

        <div class="contenedor-input type-text two-slot">
            <label for="">{{$t('registro.direccion')}}*</label>
            <input type="text" v-validate="'required|min:3|max:150'" name="direccionUsuario" v-model="newuser.direccion">
            <span class='error' v-if="clicked">{{ errors.first('direccionUsuario') }}</span>
        </div>

        <div class="contenedor-input type-text one-slot">
            <label for="">{{$t('registro.localidad')}}*</label>
            <input type="text" v-validate="'required|min:3|max:150'" name="localidadUsuario" v-model="newuser.localidad">
            <span class='error' v-if="clicked">{{ errors.first('localidadUsuario') }}</span>
        </div>

        <div class="contenedor-input type-text one-slot">
            <label for="">{{$t('registro.cp')}}*</label>
            <input type="text" v-validate="'required|min:3|max:150'" name="cpUsuario" v-model="newuser.cp">
            <span class='error' v-if="clicked">{{ errors.first('cpUsuario') }}</span>
        </div>

        <div class="contenedor-botones row-start">
            <a class="btn -solid-primary" @click="validateContacto" :loading="loading">{{$t('registro.anadir_contacto')}}</a>
            <a class="btn -skull-primary" @click="$emit('close')">{{$t('cancelar')}}</a>
        </div>


    </div>
</div>
</template>

<script lang="js">

    import Datepicker from 'vuejs-datepicker';

    import { ca, es } from 'vuejs-datepicker/dist/locale';

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);

    import { mapGetters, mapActions } from 'vuex';

    import { Validator } from 'vee-validate';


    Validator.extend('checkdni', {
        validate: value => {
            var validChars = 'ABCDEFGHJKLMNPQRSTTVWXYZ';
            var nifRexp = /^[0-9]{8}[A-Z]{1}$/i;
            var nieRexp = /^[XYZ]{1}[0-9]{7}[A-Z]{1}$/i;
            var str = value.toString().toUpperCase();

            if (!nifRexp.test(str) && !nieRexp.test(str)) return false;

            var nie = str
                .replace(/^[X]/, '0')
                .replace(/^[Y]/, '1')
                .replace(/^[Z]/, '2');

            var letter = str.substr(-1);
            var charIndex = parseInt(nie.substr(0, 8)) % 23;

            if (validChars.charAt(charIndex) === letter) return true;

            return false;
        },
        getMessage: field => 'El campo DNI está mal formado',
    });

    export default {
        name: 'add-contacto',
        data() {
            return {
                newuser: {
                    "nombre": "",
                    "apellidos": "",
                    "puesto": "",
                    "email": "",
                    "nick": "",
                    "telefono1": "",
                    "telefono2": "",
                    "password": "",
                    "departamento": "",
                    "localidad": "",
                    "idLocalidad": '',
                    "direccion": "",
                    "cp": "",
                    "nif": "",
                    "idPais": '',
                    "provincia": "",
                    "tipoContacto": ["9"],
                    "aniosForoEmpleo": "",
                    "show": false
                },
                ca: ca,
                es: es,
                clicked: false,
                loading: false
            }
        },
        computed: {
            ...mapGetters({
                dominios: 'getDominios',
                dominiosOrder: 'getDominiosOrder',
                brand: 'getBrand',
                tiposContacto: 'getTipoContactoEmpresa'
            }),
        },
        methods: {
            ...mapActions(['addContactoEmpresa']),
            validateContacto() {
                this.clicked = true;
                this.$validator.validateAll()
                    .then(itsOk => {
                        if (itsOk) {
                            this.loading = true;
                            this.clicked = false;
                            this.addContactoEmpresa(this.newuser).then(r => {
                                if(r){
                                    this.$emit('added');
                                }
                                this.loading = false;
                            });
                        }
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/views/documentacion/addContacto.vue